import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AIConfiguredModelProviders } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { invalidateModelProviders } from "./fetchModelProviders";
const useDeleteModelProvider = () => {
  const queryClient = useQueryClient();
  const sendTelemetry = useSendTelemetry();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (provider) => AIConfiguredModelProviders.deleteConfiguredProvider(provider),
    onSuccess: (_result, provider) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.AI_MANAGEMENT.MODEL_PROVIDER_DELETED, {
        app_section: "ai-management-model-providers",
        event_details: { provider }
      });
      UserNotification.success("Model provider deleted.");
      invalidateModelProviders(queryClient);
    },
    onError: (error) => UserNotification.error(`Deleting the model provider failed: ${error.message}`)
  });
  return { deleteProvider: mutateAsync, isDeleting: isPending };
};
export default useDeleteModelProvider;
